/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
//@ts-check
import React from 'react';
import { Navbar, Nav} from 'react-bootstrap';

import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from '../Buttons/SignInButton';
import { SignOutButton } from '../Buttons/SignOutButton';

import '../../styles/App.css'
import { Link } from 'react-router-dom';
import { HamburgerMenu } from '../Menus/HamburgerMenu';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle">
                {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                <HamburgerMenu/>
                <Navbar.Brand as={Link} to="/" style={{marginLeft: '14px'}}>Ecolab Identity Portal</Navbar.Brand>
                <Navbar.Collapse id="basic-navbar-nav">
                </Navbar.Collapse>
                <Nav className="ml-auto justify-content-end">
                    {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </Nav>
            </Navbar>
            {props.children}
        </>
    );
};
